const codeCurrentPage = data_handler.codeCurrentPage,
	clientUserGid = data_handler.clientUserGid,
	currentPageId = data_handler.currentPageId;

const DOMElements = {
	enterCodeButton: '#enter-code-button',
	enterCodeInput: '#enter-code-input',
};

const enterCodeButton = document.querySelector(DOMElements.enterCodeButton),
	enterCodeInput = document.querySelector(DOMElements.enterCodeInput);

const checkCode = () => {
	const hintsCurrentStorage = window.localStorage.getItem(currentPageId);
	const input = enterCodeInput.value;

	if (input === codeCurrentPage && hintsCurrentStorage > 1) {
		saveHintsAjaxSubmit(hintsCurrentStorage);
	}
};

const saveHintsAjaxSubmit = async (hintsCurrentStorage) => {
	fetch('/wp-json/bluebird-games/v1/writehintsdata/', {
		method: 'POST',
		body:
			'group_id=' +
			clientUserGid +
			'&page_id=' +
			currentPageId +
			'&hints_data=' +
			hintsCurrentStorage,
		headers: {
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
			'Access-Control-Allow-Headers': '*',
			'Content-type': 'application/x-www-form-urlencoded',
		},
	})
		.then(function (response) {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		})
		.catch(function (error) {
			console.warn('Something went wrong.', error);
		});
};

const HintsDatabaseWriter = {
	bindEvents: () => {
		if (enterCodeButton) {
			enterCodeButton.addEventListener('click', checkCode);
		}
		if (enterCodeInput) {
			enterCodeInput.addEventListener('keyup', (e) => {
				if (e.keyCode === 13) {
					e.preventDefault();
					checkCode();
				}
			});
		}
	},
};

export default HintsDatabaseWriter;
